import React from 'react';

export const Landing = () => {
  return (
    <div className="skydive-landing-container">
      <div className="skydive-landing-bottom-section">
        <div className="skydive-landing-bottom-text">
          <div className="skydive-landing-title-section">
            <h1 className="skydive-landing-subtitle">fpv.skydive</h1>
            <h2 className="skydive-landing-title">
              REALISTIC flight simulator
            </h2>
          </div>
          <div className="skydive-landing-text-section">
            <p className="skydive-landing-text">
              FPV SkyDive is your gateway into the thrilling world of FPV drone
              racing and freestyle! Feel the adrenaline of high-speed
              first-person drone flight in realistic single-player and
              multiplayer scenarios. Master your skills, push the limits, and
              take to the skies!
            </p>
            <div className="dreamX__discover--button">
              <a
                href="https://store.steampowered.com/app/1278060/FPV_SkyDive__FPV_Drone_Simulator/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="btn btn--primary btn--med"
                onMouseDown={event => event.preventDefault()}
              >
                Get Started
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
